/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

/* eslint-disable lines-between-class-members */
/**
 * Generic statuses for the async actions of thunks
 * Redux store doesn't know how to serialize complex objects (e.g. instance of a Class)
 */
export const ThunkStatus = Object.freeze({
  IDLE: 'idle',
  LOADING: 'loading',
  SUCCEEDED: 'succeeded',
  FAILED: 'failed',
});
